var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66016 11.2059L12.4102 4.45593L11.3555 3.36609L5.66016 9.0614L2.98828 6.38953L1.93359 7.44421L5.66016 11.2059ZM12.4102 0.694214C12.832 0.694214 13.1836 0.846558 13.4648 1.15125C13.7695 1.4325 13.9219 1.78406 13.9219 2.20593V12.6825C13.9219 13.1044 13.7695 13.4677 13.4648 13.7723C13.1836 14.0536 12.832 14.1942 12.4102 14.1942H1.93359C1.51172 14.1942 1.14844 14.0536 0.84375 13.7723C0.5625 13.4677 0.421875 13.1044 0.421875 12.6825V2.20593C0.421875 1.78406 0.5625 1.4325 0.84375 1.15125C1.14844 0.846558 1.51172 0.694214 1.93359 0.694214H12.4102Z",
    fill: "#001574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/check_box.36028b361dee74f529c9fbf98d1e84b3.svg";
export { ForwardRef as ReactComponent };